import React, { useCallback } from "react";

import IconButton from "@cayuse/shared-react.components.icon-button";

import CodeSearch from "components/flowable/ClassificationCodes/internal/CodeSearch";
import { useCodeValidationContext } from "components/flowable/ClassificationCodes/internal/CodeValidationContext";
import PercentTextInput from "components/PercentTextInput";
import Table from "components/Table";

import styles from "./styles.css";


export const CodeTemplateRow = ({
	index,
	searchLabel,
	percentOfResearchLabel,
	removeLabel,
	codeType,
	required,
	disabled,
	includePercentage,
	toCodeOptions,
	code,
	percentage,
	onChangeCodeObject,
	onRemoveRow,
	setTouched
}) => {
	const { onBlur, totalPercentageError, [index]: isValid } = useCodeValidationContext();

	const handleBlur = useCallback(() => onBlur(index), [ index, onBlur ]);

	return (
		<Table.Row>
			<Table.Cell className={styles.lookupColumn}>
				<div className={styles.rowField}>
					<CodeSearch
						aria-label={searchLabel}
						fluid={true}
						code={code}
						codeType={codeType}
						toCodeOptions={toCodeOptions}
						onChangeCode={code => onChangeCodeObject({ code })}
						required={required}
						disabled={disabled}
						setTouched={setTouched}
					/>
				</div>
			</Table.Cell>
			{includePercentage && (
				<Table.Cell className={styles.percentColumn}>
					<div className={styles.rowField}>
						<PercentTextInput
							aria-label={percentOfResearchLabel}
							onBlur={handleBlur}
							className={styles.percentageInput}
							disabled={disabled}
							value={percentage}
							onChange={percentage => onChangeCodeObject({ percentage })}
							required={required && (percentage === "" || percentage === null)}
							data-error={!!totalPercentageError || (isValid !== undefined && !isValid)}
							setTouched={setTouched}
						/>
					</div>
				</Table.Cell>
			)}
			<Table.Cell className={styles.buttonColumn}>
				{!disabled && onRemoveRow && (
					<IconButton
						aria-label={removeLabel}
						onClick={onRemoveRow}
						className={styles.removeButton}
						icon="times"
						tertiary
					/>
				)}
			</Table.Cell>
		</Table.Row>
	);
};
